import PropTypes from "prop-types";
import React, { Fragment, PureComponent } from "react";

import { colorMap } from "../../constants/colorOptions";
import { ADD_COLUMN_PREFIX } from "../../constants/idPrefixes";
import { PropTypeShapes } from "../../types";

// import debugUtils from "../../utils/debugUtils";

class RelationshipIntersectionView extends PureComponent {
  constructor(props, context) {
    super(props, context);
    this.onClick = this.onClick.bind(this);
  }

  onClick() {
    this.props.onClick(
      this.props.subjectId,
      this.props.subjectType,
      this.props.itemId,
      this.props.itemType,
      this.props.relationshipValues,
      this.props.id
    );
  }

  renderColumnColor() {
    const { columnColor } = this.props;
    const color = colorMap[columnColor];
    const backgroundStyle = columnColor
      ? {
        backgroundColor: color,
        opacity: 0.15
      }
      : {};

    const borderStyle = columnColor
      ? {
        background: color,
        opacity: 0.4
      }
      : {};
    return (
      <Fragment>
        <div className="rEntityColBackground" style={backgroundStyle} />
        <div className="rEntityColColorBorder" style={borderStyle} />
      </Fragment>
    );
  }

  render() {
    const elementId = this.props.id;
    const isAddNode = this.props.itemId.indexOf(ADD_COLUMN_PREFIX) > -1;

    let classNames = [`rEntityCol`];
    if (this.props.selected) {
      classNames.push("selected");
    }
    if (this.props.odd) {
      classNames.push("odd");
    }
    if (this.props.firstInGroup) {
      classNames.push("firstInGroup");
    }
    if (isAddNode) {
      classNames.push("addColumn");
    }

    const style = {
      left: `${this.props.left}px`
    };

    const children = this.props.relationshipValues
      ? this.props.relationshipValues
        .map((c, i) => (
          <div key={i} className={`relIcon ${c.icon} ${c.color}`}>
            {c.label ? c.label.charAt(0) : ""}
          </div>
        ))
        .toArray()
      : null;

    if (this.props.ageLabel) {
      children.push(
        <div key="ageLabel" className="relAgeLabel">
          {this.props.ageLabel}
        </div>
      );
    }

    return (
      <div className={classNames.join(" ")} style={style} onClick={!isAddNode ? this.onClick : null}>
        {this.renderColumnColor()}
        <div className="relIcons" id={elementId}>
          {children}
        </div>
      </div>
    );
  }
}

RelationshipIntersectionView.propTypes = {
  id: PropTypes.string.isRequired,
  viewId: PropTypes.string.isRequired,
  selected: PropTypes.bool,
  odd: PropTypes.bool,
  left: PropTypes.number.isRequired,
  firstInGroup: PropTypes.bool.isRequired,
  subjectId: PropTypes.string.isRequired,
  subjectType: PropTypes.string.isRequired,
  itemId: PropTypes.string.isRequired,
  itemType: PropTypes.string.isRequired,
  relationshipValues: PropTypeShapes.relationshipIntersectionList,
  columnColor: PropTypes.string,

  // hasValue: PropTypes.bool.isRequired,
  // icon: PropTypes.string,
  // color: PropTypes.string,
  // label: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  ageLabel: PropTypes.string
};

export default RelationshipIntersectionView;
